const as = (state) => state.automationStudio;

export const selectInstructions         = (state) => as(state).instructions;
export const selectSelectedStep         = (state) => as(state).selectedStep;
export const selectRightPanelView       = (state) => as(state).rightPanelView;
export const selectIsGenerating         = (state) => as(state).isGenerating;
export const selectIsSavedExecRecord    = (state) => as(state).isSavedExecutionRecord;
export const selectTestCompleted        = (state) => as(state).testCompleted;
export const selectIsLoadingSavedPlan   = (state) => Boolean(as(state).isLoadingSavedPlan);
export const selectSelectedEnvironment  = (state) => as(state).selectedEnvironment;
export const selectSelectedAIModel      = (state) => as(state).selectedAIModel;
export const selectSelectedAIModelIsAuto = (state) => as(state).selectedAIModelIsAuto;
export const selectReplayProgressMap    = (state) => as(state).replayProgressMap;
export const selectReplayExecResults    = (state) => as(state).replayExecutionResults;
export const selectIsReplayExecuting    = (state) => as(state).isReplayExecuting;
export const selectReplayCurrStepIdx    = (state) => as(state).replayCurrentStepIndex;
export const selectFlatStepsForReplay   = (state) => as(state).flatStepsForReplay;
export const selectIsLoadedFromTestcase = (state) => as(state).isLoadedFromTestcase;
export const selectHasExecutedInSession = (state) => as(state).hasExecutedInSession;
export const selectFileSuggestions      = (state) => as(state).fileSuggestions;
export const selectFileDescriptions     = (state) => as(state).fileDescriptions;
export const selectMcpToolsList         = (state) => as(state).mcpToolsList;
export const selectMcpToolMap           = (state) => as(state).mcpToolMap;
export const selectExecutionResults     = (state) => as(state).executionResults;
export const selectOverallStatus        = (state) => as(state).overallStatus;
export const selectAutomationError      = (state) => as(state).automationError;
export const selectScreenshots          = (state) => as(state).screenshots;
export const selectLogs                 = (state) => as(state).logs;
export const selectExecutionFlow        = (state) => as(state).executionFlow;

// Derived: is anything running
export const selectIsRunning = (state) =>
  as(state).isGenerating || as(state).isReplayExecuting;

// Derived: replay session active or finished in this browser session (not idle plan load)
export const selectIsReplayFlow = (state) => {
  const s = as(state);
  if (s.isReplayExecuting) return true;
  if (!s.hasExecutedInSession) return false;
  return Object.keys(s.replayProgressMap).length > 0 || !!s.replayExecutionResults;
};
